//
//  SDKTextCase.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var TextCase;
(function (TextCase) {
    TextCase["original"] = "Original";
    TextCase["upper"] = "Upper";
    TextCase["lower"] = "Lower";
    TextCase["camel"] = "Camel";
    TextCase["smallCaps"] = "SmallCaps";
})(TextCase || (TextCase = {}));
